export default "https://d1e6s5z4lzmgxx.cloudfront.net/1e48d3d4-9cd4-48c4-b169-1af184d58c4c/images/ob-step-7.png?ad21d422929659ba8d01d04a0516a2bc";